module.exports = __webpack_public_path__ + "img/Backtotopcarat.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Backtotopcarat.svg
// module id = 241
// module chunks = 0